/**
 * This utility class provides localization for `react-day-picker`
 * through `dayjs`.
 * See: https://react-day-picker.js.org/api/LocaleUtils/
 */
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(localeData);

const formatDate = (date: Date, format = 'L', locale = 'en'): string =>
  dayjs(date).locale(locale).format(format);

const formatDay = (day: Date, locale = 'en'): string =>
  dayjs(day).locale(locale).format('ddd ll');

const formatMonthTitle = (month: Date, locale = 'en'): string =>
  dayjs(month).locale(locale).format('MMMM YYYY');

const formatWeekdayShort = (weekday: number, locale = 'en'): string =>
  dayjs().locale(locale).localeData().weekdaysMin()[weekday];

const formatWeekdayLong = (weekday: number, locale = 'en'): string =>
  dayjs().locale(locale).localeData().weekdays()[weekday];

const getFirstDayOfWeek = (locale = 'en'): number =>
  dayjs().locale(locale).localeData().firstDayOfWeek();

const getMonths = (
  locale = 'en',
): [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
] => dayjs().locale(locale).localeData().months();

const parseDate = (str: string, format = 'L', locale = 'en'): Date =>
  dayjs(str, { format, locale }, true).toDate();

export default {
  formatDate,
  formatDay,
  formatMonthTitle,
  formatWeekdayLong,
  formatWeekdayShort,
  getFirstDayOfWeek,
  getMonths,
  parseDate,
};
